/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "@fontsource/noto-sans-sc/300.css"
import "@fontsource/noto-sans-sc/400.css"
import "@fontsource/noto-sans-sc/500.css"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"

import React from "react"
import { Helmet } from "react-helmet"
import { logPageView } from "@tidb-community/tracking-script"

import 'tdesign-react/es/style/index.css'
// import 'tdesign-react/dist/reset.css' // dont need to import this now, refer to https://tdesign.tencent.com/react/getting-started#reset-%E6%A0%B7%E5%BC%8F

const getIconHref = filename => `/favicons/${filename}`

export const wrapPageElement = ({ element }) => (
  <>
    <Helmet>
      {/* favicons should be generated by https://realfavicongenerator.net/ */}
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={getIconHref("apple-touch-icon.png")}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={getIconHref("favicon-32x32.png")}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={getIconHref("avicon-16x16.png")}
      />
      <link rel="manifest" href="https://img1.pingcap.com/dist/media/favicon/site.webmanifest" />
      <link rel="shortcut icon" href={getIconHref("favicon.ico")} />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
    {element}
  </>
)

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (process.env.NODE_ENV === "production") {
    logPageView()
  }
  if (location?.state) {
    location.state.referrer = prevLocation?.pathname
  }
}
